var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiven(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14L8 8M8 8L10 10.2222M8 8L6 10.2222",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6666 4.66663V8.66663C13.6666 11.1808 13.6666 12.4379 12.8855 13.2189C12.1045 14 10.8474 14 8.33325 14H7.66658C5.15243 14 3.89535 14 3.1143 13.2189C2.33325 12.4379 2.33325 11.1808 2.33325 8.66663V4.66663",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 3.33333C1.33325 2.70479 1.33325 2.39052 1.52851 2.19526C1.72378 2 2.03805 2 2.66659 2H13.3333C13.9618 2 14.2761 2 14.4713 2.19526C14.6666 2.39052 14.6666 2.70479 14.6666 3.33333C14.6666 3.96187 14.6666 4.27614 14.4713 4.4714C14.2761 4.66667 13.9618 4.66667 13.3333 4.66667H2.66659C2.03805 4.66667 1.72378 4.66667 1.52851 4.4714C1.33325 4.27614 1.33325 3.96187 1.33325 3.33333Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiven);
export default __webpack_public_path__ + "static/media/given.1a3a016e5f67e80b483c7d11e1fa8755.svg";
export { ForwardRef as ReactComponent };